<template >
  <v-layout>
    <v-panel
      contextual-style="primary"
    >
      <h1 class="panel-title" slot="heading">
        {{ addedit }} User
      </h1>
      <div slot="body">


                <form @submit.prevent="doNothing()">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <button disabled type="button" class="btn btn-default" aria-label="Help">Name</button>
                    </div>
                    <input :readonly="doingSomething || formdata.user_id" v-model="formdata.name" autofocus class="form-control" aria-label="User's  name" placeholder="Full Name (eg: Bob Smith)">
                  </div>
                  <br />
                  <div class="input-group">
                    <div class="input-group-btn">
                      <button disabled type="button" class="btn btn-default" aria-label="Help">E-Mail</button>
                    </div>
                    <input :readonly="doingSomething || formdata.user_id" v-model="formdata.email" autofocus class="form-control" aria-label="Email" placeholder="E-Mail address (eg: me@here.com)">
                  </div>
                  <br />
                  <div class="input-group">
                    <div class="input-group-btn">
                      <button disabled type="button" class="btn btn-default" aria-label="Help">Roles</button>
                    </div>
                    <!-- <br /> -->
                    <div class="input-group" style="margin-left: 10px">

                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" v-model="formdata.roles_lists" value="" :checked="formdata.roles_lists">
                        Manage Lists
                      </label><br />
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" v-model="formdata.roles_profiles" value="" :checked="formdata.roles_profiles">
                        Manage Profiles
                      </label><br />
                      <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" v-model="formdata.roles_admin" value="" :checked="formdata.roles_admin">
                        User Administration
                      </label><br />
                    </div>
                  </div>

                    <br />
                    <div style="width:100%;" align="center">
                      <button @click="save()" v-bind:disabled="doingSomething" type="button" class="btn btn-info">{{ saveAdd }}</button>&nbsp;&nbsp;&nbsp;&nbsp;
                      <span>
                        <button @click="deleteuser()" v-bind:disabled="doingSomething" type="button" class="btn btn-warning">Delete</button>&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                      <button @click="cancel()" v-bind:disabled="doingSomething" type="button" class="btn btn-fail">Cancel</button><br />
                      <span class="error" style="color: #ff3333"><br />{{ errmsg }}</span><br />
                    </div>
                </form>


      </div>
    </v-panel>
  </v-layout>
</template>
<script>

import Vue from 'vue';
import acctService from '../../../services/account';
import store from '../../../store';

export default {
  data() {
    return {
      doingSomething: false,
      errmsg: '',
      thisuser: store.state.account.edituser,
      addedit: 'Add',
      saveAdd: 'Add',
      canDelete: false,
      formdata: {
        name: '',
        email: '',
        roles_admin: false,
        roles_profiles: false,
        roles_lists: false,
      },
    };
  },
  methods: {
    cancel() {
      Vue.router.push({
        name: 'admin.user-list',
      });
    },
    removeStringFromArray(s, sa) {
      if (!Array.isArray(sa)) {
        return sa;
      }
      const newarray = [];
      for (let i = 0; i < sa.length; i += 1) {
        if (sa[i] !== s) {
          newarray.push(sa[i]);
        }
      }
      return newarray;
    },
    addStringToArray(s, sa) {
      if (!Array.isArray(sa)) {
        return [s];
      }
      for (let i = 0; i < sa.length; i += 1) {
        if (sa[i] === s) {
          return sa;
        }
      }
      sa.push(s);
      return sa;
    },
    getuserobj(baseobj) {
      const resp = {
        name: baseobj.name,
        email: baseobj.email,
      };

      if (baseobj.roles_lists) {
        resp.roles = this.addStringToArray('lists', resp.roles);
      } else {
        resp.roles = this.removeStringFromArray('lists', resp.roles);
      }

      if (baseobj.roles_admin) {
        resp.roles = this.addStringToArray('admin', resp.roles);
      } else {
        resp.roles = this.removeStringFromArray('admin', resp.roles);
      }

      if (baseobj.roles_profiles) {
        resp.roles = this.addStringToArray('profiles', resp.roles);
      } else {
        resp.roles = this.removeStringFromArray('profiles', resp.roles);
      }
      return resp;
    },
    deleteuser() {
      const vm = this;
      const cbSuccess = function cbSuccess() {
        vm.errmsg = '';
        // console.log('delete ok');
        vm.cancel();
      };
      const cbFail = function cbFail() {
        vm.errmsg = 'Error deleting user';
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      // console.log('userobj');
      // console.log(userobj);
      acctService.delcustomeruser(store.state.auth.selected_sp.sp_id,
        this.user_id,
        cbOptions);
    },
    save() {
      const userobj = this.getuserobj(this.formdata, this.formdata);
      if (this.user_id && this.user_id > 0) {
        userobj.user_id = this.user_id;
      }

      const vm = this;
      const cbSuccess = function cbSuccess() {
        vm.errmsg = '';
        vm.formdata = store.state.account.edituser;
        vm.cancel();
      };
      const cbFail = function cbFail() {
        vm.errmsg = 'Error saving user';
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      // console.log('userobj');
      // console.log(userobj);
      acctService.setcustomeruser(store.state.auth.selected_sp.sp_id,
        userobj,
        cbOptions);
    },
    loaduser(userid) {
      if (userid && userid > 0) {
        this.addedit = 'Edit';
        this.saveAdd = 'Save';
        this.canDelete = true;
        this.user_id = userid;
        const vm = this;
        const cbSuccess = function cbSuccess() {
          vm.formdata = store.state.account.edituser;
        };
        const cbOptions = {
          cbSuccess,
        };
        acctService.getuser(store.state.auth.selected_sp.sp_id, userid, cbOptions);
      } else {
        this.addedit = 'Add';
        this.saveAdd = 'Add';
        this.canDelete = false;
      }
    },
  },
  beforeMount() {
    this.loaduser(this.$route.params.user_id);
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
tr.editable:hover {
  background: #eeeef2;
  /*cursor:context-menu;*/
  cursor:pointer;
}
td.green {
  color: #00aa00;
}
span.readonly {
  color: #aaaaaa;
}
td.red {
  color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// index.vue?f5d18c96